import React from "react";
import "./App.css";
import ReactJson from "react-json-view";
import ReactGA from "react-ga";
import AmplifyConfiguration from "./components/amplify_configuration";
import SignOps from "./components/sign_ops";
import ConfirmationCode from "./components/confirmation_code";
import GetJwtApp from "./core_app/main";


ReactGA.initialize("UA-154688669-1");
ReactGA.pageview("GetJWT");


class App extends React.Component {
  constructor(props) {
    super(props);
    this.getJwtApp = new GetJwtApp();

    const last_region = localStorage.getItem("@getjwt/region");
    const last_pool = localStorage.getItem("@getjwt/pool");
    const last_client = localStorage.getItem("@getjwt/client");
    const last_username = localStorage.getItem("@getjwt/username");
    const last_password = localStorage.getItem("@getjwt/password");

    this.state = {
      region: last_region || "us-east-1",
      userPoolId: last_pool || "",
      userPoolWebClientId: last_client || "",
      username: last_username || "",
      password: last_password || "",
      new_password: "",
      console: "Ready!\n",
      code: "",
      show_change_password: false,
      user: null,
    };
  }

  configure() {
    ReactGA.event({ category: "Tool", action: "configure" });
    this.getJwtApp.signOps.configure(
      this.state.region,
      this.state.userPoolId,
      this.state.userPoolWebClientId);

    localStorage.setItem("@getjwt/region", this.state.region);
    localStorage.setItem("@getjwt/pool", this.state.userPoolId);
    localStorage.setItem("@getjwt/client", this.state.userPoolWebClientId);

    this.add_console("Configuração realizada.");
  }

  handleChange(ev) {
    this.setState({ [ev.target.id]: ev.target.value });
  }

  updateSignOps() {
    this.getJwtApp.signOps.setData(this.state.username, this.state.password);
    return this.getJwtApp.signOps;
  }

  signup() {
    this.add_console("Realizando signup...");
    this.updateSignOps().signUp()
      .then((res) => {
        ReactGA.event({ category: "Tool", action: "signup-success" });
        this.add_console("Signup realizado", res);
      })
      .catch((error) => {
        ReactGA.event({ category: "Tool", action: "signup-failed" });
        this.add_console("Erro fazendo signup", error);
      });
    localStorage.setItem("@getjwt/username", this.state.username);
    localStorage.setItem("@getjwt/password", this.state.password);
  }

  signin() {
    this.add_console("Realizando login...");
    this.updateSignOps().signIn()
      .then((res) => {
        ReactGA.event({ category: "Tool", action: "signin-success" });
        this.setState({ JWT: res.signInUserSession.idToken.jwtToken });
        this.add_console("Login done", res);
        console.log(res);
      })
      .catch((error) => {
        if(error.message === 'NEW_PASSWORD_REQUIRED'){
          console.info("NEW_PASSWORD_REQUIRED. Required Attributes:", error.user.challengeParam);
          this.setState({ show_change_password: true, user: error.user});
          alert('É necessário alterar a senha. \nInsira a nova senha em "New Password" e clique em "Change Password"');
          return;
        }
        ReactGA.event({ category: "Tool", action: "signin-failed" });
        this.add_console("Fail to login", error);
      });
    localStorage.setItem("@getjwt/username", this.state.username);
    localStorage.setItem("@getjwt/password", this.state.password);
  }

  signout() {
    ReactGA.event({ category: "Tool", action: "sign out" });
    this.add_console("Realizando logout...");
    this.getJwtApp.signOps.signOut()
      .then(res => this.add_console("Logout done."))
      .catch(err => {
        this.add_console('Fail to logout', err);
      });
  }

  getJwt() {
    ReactGA.event({ category: "Tool", action: "getJwt" });
    this.getJwtApp.signOps.getJwt()
      .then(res => this.add_console("Token copiado no clipboard.", res))
      .catch(err => this.add_console("Fail to get JWT", err));
  }

  add_console(text, Json) {
    const time = new Date().toISOString();
    let newState = { console: `${this.state.console}\n${time}: ${text}` };
    if (Json) {
      newState.Json = Json;
    }

    this.setState(newState);
    setTimeout(() => {
      this.textLog.scrollTop = this.textLog.scrollHeight;
    }, 10);
  }

  confirmRegistrationCode() {
    this.updateSignOps().confirmSignup(this.state.code)
      .then((res) => {
        ReactGA.event({ category: "Tool", action: "confirm success" });
        this.add_console("Confirmation done", res);
      })
      .catch((error) => {
        ReactGA.event({ category: "Tool", action: "confirm failed" });
        this.add_console("Fail to confirm code", error);
      });
  }

  confirmForgotPasswordCode() {
    this.updateSignOps().confirmForgotPassword(this.state.code)
      .then((res) => {
        ReactGA.event({
          category: "Tool",
          action: "confirm forgot password success",
        });
        this.add_console("Password confirmation done", res);
      })
      .catch((error) => {
        ReactGA.event({
          category: "Tool",
          action: "confirm forgot password failed",
        });
        this.add_console("Fail to confirm forgot password code", error);
      });
  }

  forgotPassword() {
    const { username } = this.state;
    this.add_console(`Sending forgotPassword(${username})...`);
    ReactGA.event({ category: "Tool", action: "Invoke forgotPassword" });
    this.updateSignOps().forgotPassword()
      .then((response) => {
        ReactGA.event({
          category: "Tool",
          action: "Invoke forgotPassword success",
        });
        this.add_console("ForgotPassword invoked successfully.", response);
      })
      .catch((error) => {
        ReactGA.event({
          category: "Tool",
          action: "Invoke forgotPassword failed",
        });
        this.add_console("ForgotPassword invocation failed.", error);
      });
  }

  resendCode() {
    const { username } = this.state;
    this.add_console(`Sending resendeCode(${username})...`);
    ReactGA.event({ category: "Tool", action: "Invoke resendeCode" });
    this.updateSignOps().resendCode()
      .then((response) => {
        ReactGA.event({
          category: "Tool",
          action: "Invoke resendeCode success",
        });
        this.add_console("ResendeCode invoked successfully.", response);
      })
      .catch((error) => {
        ReactGA.event({
          category: "Tool",
          action: "Invoke resendeCode failed",
        });
        this.add_console("ResendeCode invocation failed.", error);
      });
  }

  changePassword() {
    this.add_console("Forced change password in progress...");

    this.updateSignOps().changePassword(this.state.user, this.state.new_password)
      .then((res) => {
        ReactGA.event({ category: "Tool", action: "change-password-success" });
        // this.setState({ JWT: res.signInUserSession.idToken.jwtToken });
        this.add_console("Password change done", res);
        console.log(res);
      })
      .catch((error) => {
        ReactGA.event({ category: "Tool", action: "signin-failed" });
        this.add_console("Fail to change password", { error });
        console.error("Fail to change password", error);
      });
    localStorage.setItem("@getjwt/username", this.state.username);
    localStorage.setItem("@getjwt/password", this.state.password);
    this.setState({ show_change_password: false });
  }

  render() {
    let jsonviewer = <div/>;
    if (this.state.Json) {
      jsonviewer = (
        <ReactJson
          className="reactjson"
          src={JSON.parse(JSON.stringify(this.state.Json))}
          theme="monokai"
          collapseStringsAfterLength={80}
          collapsed={1}
          indentWidth={2}
          defaultValue="object"
          style={{
            maxWidth: "100vw",
            width: "90%",
            marginTop: "1em",
          }}
        />
      );
    }

    return (
      <div className="App">
        <AmplifyConfiguration
          region={this.state.region}
          poolId={this.state.userPoolId}
          clientSecret={this.state.userPoolWebClientId}
          onConfigure={this.configure.bind(this)}
          onGetJwt={this.getJwt.bind(this)}
          onSignOut={this.signout.bind(this)}
          handleChange={this.handleChange.bind(this)}
        />
        <SignOps
          handleChange={this.handleChange.bind(this)}
          password={this.state.password}
          new_password={this.state.new_password}
          username={this.state.username}
          showForgotPassword={this.state.show_change_password}
          onSignin={this.signin.bind(this)}
          onForgotPassword={this.forgotPassword.bind(this)}
          onChangePassword={this.changePassword.bind(this)}
          onResendCode={this.resendCode.bind(this)}
          onSignup={this.signup.bind(this)}

        />
        <ConfirmationCode
          code={this.state.code}
          onConfirmForgotPasswordCode={this.confirmForgotPasswordCode.bind(this)}
          onConfirmRegistrationCode={this.confirmRegistrationCode.bind(this)}
          handleChange={this.handleChange.bind(this)}
        />

        <textarea
          id="console"
          rows="10"
          value={this.state.console}
          ref={(textLog) => (this.textLog = textLog)}
          readOnly={true}
        ></textarea>

        {jsonviewer}
      </div>
    );
  }
}

export default App;
